import { getSchedulerDataServicesMaintenance } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"
export function ElectricalMaintenance() {


  let servicesStart = [{
    id: "Member Maintenance",
    label: <>Member Maintenance</>,
    jobType: "Electrical Inspection: Member",
    data: [],
  },
  {
    id: "Generator Maintenance",
    label: <>Generator Maintenance</>,
    data: [
      [
        {
          name: "GeneratorMaintenance",
          question: "Are you a maintenance program member?",
          answers: [
            {
              id: "Yes",
              label: <>Yes</>,
              value: "Yes",
              jobType: "Generator: Member",
              remType: "maintenance"
            },
            {
              id: "No",
              label: <>No</>,
              value: "No",
              jobType: "Generator: Non-Member",
              remType: "maintenance"
            },
          ],
        },
      ],
    ],
  },

  {
    id: "Electrical Inspection",
    label: <>Electrical Inspection</>,
    data: [
      [
        {
          name: "ElectricalInspection",
          question: "Are you a maintenance program member?",
          answers: [
            {
              id: "Yes",
              label: <>Yes</>,
              value: "Yes",
              jobType: "Electrical Inspection: Member",
              remType: "maintenance"
            },
            {
              id: "No",
              label: <>No</>,
              value: "No",
              jobType: "Electrical Inspection: Non-Member",
              remType: "maintenance"
            },
          ],
        },
      ],
    ],
  },
  ];

  const jobTypeFilter = getSchedulerDataServicesMaintenance// Replace with the desired job type to filter
  
  return filteredServicesComponents(servicesStart, jobTypeFilter);

}